import { Pipe, PipeTransform } from '@angular/core';
import { AssetDto } from '@nusign/picflow-backend-types';
import { CommentThread } from '../gallery-shared/components/comments/comments.component';

@Pipe({
  name: 'canShowFace',
  standalone: true,
})
export class CanShowFacePipe implements PipeTransform {
  transform(thread: CommentThread, asset: AssetDto, videoOk: boolean, activePage: number): boolean {
    if (thread.position?.frame === undefined) return true;
    if (asset.type === 'video') return videoOk;
    if (asset.type === 'document' && asset.version_data.asset_name.endsWith('pdf')) {
      return thread.position.frame === activePage;
    }
    return true;
  }
}
